/* Baukasten-Verhalten v24-a. Bewusst klein und ohne externe Anfrage. */
(function () {
  'use strict';

  // Mobiles Menü (Gesetz 20: aufgeklappt ist es ein Blatt)
  var burger = document.querySelector('.kopf__burger');
  var nav = document.querySelector('.kopf__nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var offen = nav.classList.toggle('offen');
      burger.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
  }

  // Filter und Sortierung wenden sich mit JavaScript selbst an; der
  // Anwenden-Knopf verschwindet dann. Ohne JavaScript bleibt er stehen und
  // das GET-Formular arbeitet unverändert — jede Anwendung ist eine echte
  // Navigation, Vor/Zurück und geteilte Links funktionieren von selbst.
  var filterForm = document.querySelector('form.filter[data-filter-auto]');
  if (filterForm) {
    var anwendenKnopf = filterForm.querySelector('.filter__anwenden');
    if (anwendenKnopf) anwendenKnopf.hidden = true;
    var preisZoegern = null;
    var preisWartet = false;
    var abschicken = function () {
      preisWartet = false;
      clearTimeout(preisZoegern);
      if (typeof filterForm.requestSubmit === 'function') filterForm.requestSubmit();
      else filterForm.submit();
    };
    filterForm.addEventListener('change', function (event) {
      var feld = event.target;
      if (feld.matches('input[type="checkbox"], select')) { abschicken(); return; }
      if (feld.matches('input[type="number"]')) {
        // 'change' feuert erst beim Verlassen des Felds oder bei Enter — nie
        // mitten im Tippen. Der kurze Aufschub fängt zusätzlich den Sprung
        // Von→Bis ab: Solange der Fokus nur ins Nachbar-Preisfeld wandert,
        // wird das halb ausgefüllte Paar nicht abgeschickt. Die Anwendung
        // verfällt dabei nicht — sie bleibt offen (preisWartet) und wird
        // beim Verlassen des Preispaars nachgeholt, auch wenn das zweite
        // Feld unverändert bleibt und deshalb selbst kein change feuert.
        clearTimeout(preisZoegern);
        preisWartet = true;
        preisZoegern = setTimeout(function () {
          var fokus = document.activeElement;
          if (fokus && fokus !== feld && filterForm.contains(fokus)
              && fokus.matches('input[type="number"]')) return;
          abschicken();
        }, 180);
      }
    });
    filterForm.addEventListener('focusout', function (event) {
      if (!preisWartet) return;
      var ziel = event.relatedTarget;
      if (ziel && filterForm.contains(ziel)
          && ziel.matches && ziel.matches('input[type="number"]')) return;
      abschicken();
    });
  }

  // Zwei-Klick-Karte im Ladenabschnitt: Google Maps laedt erst nach dem
  // ausdruecklichen Klick — vorher existiert kein iframe, kein Abruf, kein
  // Key, kein Storage. Ohne JavaScript bleibt der Knopf verborgen (hidden)
  // und der Routenlink ist der Weg; darum wird er hier erst sichtbar.
  var ladenKarte = document.querySelector('[data-laden-karte]');
  if (ladenKarte) {
    var karteKnopf = ladenKarte.querySelector('[data-karte-laden]');
    var karteFlaeche = ladenKarte.querySelector('[data-karte-flaeche]');
    if (karteKnopf && karteFlaeche) {
      karteKnopf.hidden = false;
      karteKnopf.addEventListener('click', function () {
        var rahmen = document.createElement('iframe');
        rahmen.title = 'Google-Maps-Karte: An & Verkauf, Bahnhofstraße 68, 48143 Münster';
        rahmen.src = 'https://www.google.com/maps?q=' +
          encodeURIComponent('An & Verkauf, Bahnhofstraße 68, 48143 Münster') +
          '&hl=de&z=16&output=embed';
        rahmen.setAttribute('loading', 'lazy');
        rahmen.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        rahmen.setAttribute('allowfullscreen', '');
        karteFlaeche.textContent = '';
        karteFlaeche.appendChild(rahmen);
        karteKnopf.hidden = true;
        var hinweis = document.getElementById('laden-karte-hinweis');
        if (hinweis) hinweis.textContent = 'Karte von Google Maps geladen.';
        rahmen.focus();
      });
    }
  }

  // Zeitangaben („vor 3 Std.“, „gestern“) rechnet seit 1.6.36 der Browser.
  // Shopify liefert Seiten aus dem Zwischenspeicher; eine beim Rendern
  // berechnete Angabe war dort schon Stunden alt und sprang beim Neuladen
  // (Serkans Meldung vom 03.10.2026). Unter 24 Stunden zählen Stunden; ab dann
  // Kalendertage in deutscher Zeit, damit „gestern“ wirklich gestern heißt
  // (vorher galt alles von 24 bis 48 Stunden als „gestern“).
  // data-zeit-bis: älter als so viele Sekunden → nichts zeigen (Ticker: 24 h).
  var datumFormat = { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' };
  var tagBerlin = function (sekunden) {
    var iso = new Date(sekunden * 1000).toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' }); // JJJJ-MM-TT
    return Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)) / 86400000;
  };
  var zeitenSetzen = function () {
    var jetzt = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-zeit]').forEach(function (el) {
      var quelle = parseInt(el.getAttribute('data-zeit'), 10);
      if (!quelle) return;
      var alter = jetzt - quelle;
      // Geht die Uhr des Geräts ein paar Minuten nach, zählt das als „gerade eben“.
      if (alter < 0 && alter > -600) alter = 0;
      var bis = parseInt(el.getAttribute('data-zeit-bis') || '0', 10);
      if (bis && (alter < 0 || alter >= bis)) { el.hidden = true; return; }
      var minuten = Math.floor(alter / 60), stunden = Math.floor(minuten / 60), tage;
      var text;
      if (alter < 0) text = new Date(quelle * 1000).toLocaleDateString('de-DE', datumFormat);
      else if (minuten < 2) text = 'gerade eben';
      else if (minuten < 60) text = 'vor ' + minuten + ' Min.';
      else if (stunden < 24) text = 'vor ' + stunden + ' Std.';
      else {
        tage = tagBerlin(jetzt) - tagBerlin(quelle);
        if (tage <= 1) text = 'gestern';
        else if (tage < 7) text = 'vor ' + tage + ' Tagen';
        else text = new Date(quelle * 1000).toLocaleDateString('de-DE', datumFormat);
      }
      if (el.textContent !== text) el.textContent = text;
      el.hidden = false;
    });
  };
  zeitenSetzen();
  setInterval(zeitenSetzen, 60000);

  // Live-Ticker: Inhalt einmal duplizieren, damit der Lauf nahtlos umschlägt.
  // Bei reduzierter Bewegung bleibt es eine scrollbare Zeile (siehe kit.css).
  // 1.6.37 (T10): Die Kopien sind für Screenreader nur Optik. aria-hidden allein
  // ließ ihre Links per Tab erreichbar (axe „aria-hidden-focus“, 6 Links je Seite).
  // tabindex=-1 nimmt sie aus der Tab-Reihenfolge; anklicken lassen sie sich
  // weiter, denn sichtbar laufen sie wie das Original durchs Band (kein inert).
  var lauf = document.querySelector('.ticker__lauf');
  if (lauf && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    lauf.innerHTML += lauf.innerHTML;
    lauf.querySelectorAll(':scope > *').forEach(function (el, i, alle) {
      if (i >= alle.length / 2) {
        el.setAttribute('aria-hidden', 'true');
        if (el.matches('a')) el.setAttribute('tabindex', '-1');
        el.querySelectorAll('a, button').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
      }
    });
  }

  // Variantenpreis: Die Farbwahl bleibt eine reine Radiogruppe (ohne Skript
  // steht der Preis am Zettel). Mit JavaScript zieht der große Preis nach, und
  // die Adresse merkt sich die Variante, damit ein Neuladen denselben Preis zeigt.
  // 1.6.37 (T18): Auch Bestand und Mengenwahl folgen der gewählten Farbe. Vorher
  // galt die Mengenwahl der Startfarbe; bei 3 Stück Grün und 1 Stück Blau bot die
  // Seite für Blau „3“ an, und /cart/add scheiterte mit Shopifys Fehlerseite.
  var bestandSetzen = function (wahl) {
    var roh = wahl.getAttribute('data-bestand');
    if (roh === null) return;
    var bestand = parseInt(roh, 10) || 0;
    var anzeige = document.querySelector('[data-bestand-anzeige]');
    if (anzeige && bestand > 0) anzeige.textContent = 'Noch ' + bestand + ' verfügbar';
    var mengen = document.querySelectorAll('.pdp__kauf input[name="quantity"][type="radio"]');
    var gewaehlt = null;
    mengen.forEach(function (m) {
      var zuViel = (parseInt(m.value, 10) || 1) > Math.max(bestand, 1);
      m.disabled = zuViel;
      if (m.closest('label')) m.closest('label').hidden = zuViel;
      if (m.checked) gewaehlt = m;
    });
    if (gewaehlt && gewaehlt.disabled && mengen[0]) mengen[0].checked = true;
    var feld = document.querySelector('.pdp__kauf input[name="quantity"][type="number"]');
    if (feld) {
      feld.max = Math.max(bestand, 1);
      if ((parseInt(feld.value, 10) || 1) > Math.max(bestand, 1)) feld.value = Math.max(bestand, 1);
    }
  };
  var variantenPreis = document.querySelector('[data-variantenpreis]');
  if (variantenPreis) {
    document.querySelectorAll('.pdp__kauf input[name="id"][data-preis]').forEach(function (wahl) {
      wahl.addEventListener('change', function () {
        if (!wahl.checked) return;
        variantenPreis.textContent = wahl.getAttribute('data-preis');
        bestandSetzen(wahl);
        if (window.history && history.replaceState) {
          var adresse = new URL(window.location.href);
          adresse.searchParams.set('variant', wahl.value);
          history.replaceState(null, '', adresse.toString());
        }
      });
    });
  }

})();
